import '../css/flipbook_title_page.css';
import 'jquery-migrate';
import $ from 'jquery';

$.browser = {}; // Needed to stop thickbox from exploding
window.jQuery = window.$ = window.$j = $; // Needed for flipbook scripts below and thickbox

// Use require for these to ensure they load after the above line

/**
 * Most of these are *probably* not needed on this page, but are being added for legacy
 */
require('./flipbook3/jquery/jquery.field');
require('./flipbook3/jquery/jquery.form');
require('./flipbook3/jquery/jquery.tooltip.pack');
require('./flipbook3/default');
require('./flipbook3/json');
require('./static/swfobject.2.1');

function init({
  g_webroot,
  g_img_url,
  g_titleId, //eslint-disable-line
  g_issueId, //eslint-disable-line
  subscribeNowUrl,
  shouldSubscribeNowOnLoad,
}) {
  window.g_img_url = g_img_url; // needed for thickbox
  require('./flipbook3/thickbox');

  function subscribeNow() {
    if (!window.loadTB) {
      return;
    }
    window.loadTB('Subscribe Now', subscribeNowUrl);
  }

  if (shouldSubscribeNowOnLoad) {
    subscribeNow();
  }

  $(document).ready(function () {
    $('.js-loadArchive').on('click', function loadArchives() {
      if (!window.loadTB) {
        return;
      }
      window.loadTB(
        'Archives',
        g_webroot + 'read/archives/issue/' + g_titleId + '/' + g_issueId + '?width=440&height=550',
      );
    });

    $('.js-subscribeNow').on('click', subscribeNow);
  });
}

export { init };
